import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=4395fae5&scoped=true&"
import script from "./avatar.vue?vue&type=script&lang=js&"
export * from "./avatar.vue?vue&type=script&lang=js&"
import style0 from "./avatar.vue?vue&type=style&index=0&id=4395fae5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4395fae5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4395fae5')) {
      api.createRecord('4395fae5', component.options)
    } else {
      api.reload('4395fae5', component.options)
    }
    module.hot.accept("./avatar.vue?vue&type=template&id=4395fae5&scoped=true&", function () {
      api.rerender('4395fae5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/rolls/components/avatar.vue"
export default component.exports